import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const updateUserApi = createAsyncThunk(
  "updateUseData",
  async (userData) => {
    console.log(userData);
    const updateUserData = new FormData();

    updateUserData.append("name", userData.name);
    updateUserData.append("mobile", userData.mobile);
    updateUserData.append("email", userData.email);
    updateUserData.append("role", userData.role);
    updateUserData.append("title", userData.title);

    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/update/${userData._id}`,
      {
        method: "POST",

        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
        body: updateUserData,
      }
    )
      .then((respons) => respons.json())
      .then((resulet) => {
       
        return resulet;
      })
      .catch((e) => {
        
        return e;
      });

    return request;
  }
);

const updateUsersSlicer = createSlice({
  name: "user/update",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(updateUserApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateUserApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === " User updated Successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
      }
    });

    builder.addCase(updateUserApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

export default updateUsersSlicer.reducer;
